import * as React from 'react';

export interface LiveData {
  id: string,
  title: string,
  slug: string,
  imageUrl: string,
}

export interface GlobalContextData {
  liveItems: LiveData[],
  extendedPushDown: Boolean,
  setExtendedPushDown: Function,
  showModal: string,
  setShowModal: Function,
}
export const GlobalContext = React.createContext<GlobalContextData | null>(null);

export const GlobalContextProvider = GlobalContext.Provider;
export const GlobalContextConsumer = GlobalContext.Consumer;
